import { put, takeLatest } from "redux-saga/effects";
import { actionTypes } from "Redux/services/actionTypes";
import apiCall from "Redux/services/apiCall";
import { API_PROMO_CODE } from "Redux/services/apiTypes";

// ----- Get Promo Code Watcher -----
export function* watchGetPromoCodeSaga() {
  yield takeLatest(actionTypes.GET_PROMO_CODE_METHOD, getPromoCodeSaga);
}
export function* watchGetSinglePromoCodeSaga() {
  yield takeLatest(
    actionTypes.GET_SINGLE_PROMO_CODE_METHOD,
    getSinglePromoCodeSaga
  );
}

// ----- Saga -----
function* getPromoCodeSaga(action) {
  try {
    let url = {
      type: API_PROMO_CODE + action.payload.query,
      payload: action.payload,
      apiType: "GET",
    };
    const res = yield apiCall(url);
    yield put({ type: actionTypes.GET_PROMO_CODE_SUCCESS, payload: res });
  } catch (error) {
    yield put({ type: actionTypes.GET_PROMO_CODE_FAIL, payload: error });
  }
}
function* getSinglePromoCodeSaga(action) {
  try {
    let url = {
      type: `${API_PROMO_CODE}${action.payload}/`,
      payload: action.payload,
      apiType: "GET",
    };
    const res = yield apiCall(url);
    yield put({
      type: actionTypes.GET_SINGLE_PROMO_CODE_SUCCESS,
      payload: res,
    });
  } catch (error) {
    yield put({ type: actionTypes.GET_SINGLE_PROMO_CODE_FAIL, payload: error });
  }
}
